module.exports = __webpack_public_path__ + "img/totalsins_spritesheet.587ca23e.png";